import { useEffect, useState } from 'react';
import {
  addZeroToStartLine,
  getBannerLastTime,
  setBannerTime,
} from '../services';
import { ITimer, ITimerState } from '../types';

export const useTimer = (timeFrom: number, id: string): ITimer => {
  const [timerState, setTimerState] = useState<ITimerState>({
    isRunning: false,
    time: null,
    timeInterval: null,
  });
  const { isRunning, time, timeInterval } = timerState;

  const stopTimer = () => {
    timerState.isRunning && setTimerState({ ...timerState, isRunning: false });
    timeInterval && clearInterval(timeInterval);
  };

  const startTimer = () => {
    if (!time || !!timeInterval) {
      return null;
    }

    setTimerState((prev) => ({
      ...prev,
      isRunning: true,
      timeInterval: setInterval(() => {
        setTimerState((prevState) => ({
          ...prevState,
          time: prevState.time ? prevState.time - 1 : 0,
        }));
      }, 1000),
    }));
  };

  useEffect(() => {
    const bannerLastTimeFromStorage = getBannerLastTime(id);
    const initialTime = !!bannerLastTimeFromStorage
      ? parseInt(bannerLastTimeFromStorage)
      : timeFrom * 60;

    setTimerState((prevState) => ({ ...prevState, time: initialTime }));

    return () => stopTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isRunning && typeof time == 'number') {
      setBannerTime(id, time);
      if (time == 0) {
        stopTimer();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time]);

  // Convert seconds to minutes, and seconds
  const minutes = time ? Math.floor((time % 3600) / 60) : 0;
  const seconds = time ? time % 60 : 0;

  return {
    minutes: addZeroToStartLine(minutes),
    seconds: addZeroToStartLine(seconds),
    stopTimer,
    startTimer,
    timerState,
  };
};
